<template>
  <el-dialog
    :custom-class="'common-dialog-box'"
    :title="title"
    :visible.sync="visible"
    :show-close="showClose"
    :width="width"
    :close-on-click-modal="false"
    @close="handleClose"
    :before-close="beforeClose"
    :top="top"
  >
    <slot name="dialog-content"></slot>  <!-- 插槽，用于弹窗内自定义内容 -->
    <span slot="footer" class="dialog-footer" v-if="footer">
      <el-button size="medium" @click="handleClose">取消</el-button>
      <el-button size="medium" type="primary" @click="confirmAction" :disabled="disabled">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    // 弹窗的标题
    title: {
      type: String,
      default: '弹窗'
    },
    // 弹窗的宽度
    width: {
      type: String,
      default: '70%'
    },
    top: {
      type: String,
      default: '60px'
    },
    // 控制弹窗是否可见
    value: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.value // 控制弹窗的显示和隐藏
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('input', val); // 向父组件传递更新的值
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('close'); // 触发父组件的 confirm 事件
      this.visible = false;
    },
    // 确定按钮的回调
    confirmAction() {
      this.$emit('confirm'); // 触发父组件的 confirm 事件
      if (!this.value) {
        this.handleClose(); // 关闭弹窗
      }
    },
    // 在关闭弹窗前执行的函数
    beforeClose(done) {
      // 可以在这里执行一些操作，比如确认提示等
      this.$emit('beforeClose'); // 触发父组件的 confirm 事件
      done();
    }
  }
};
</script>

<style lang='scss'>
.common-dialog-box.el-dialog {
  height: calc(100% - 90px);
}
.common-dialog-box {
  .el-dialog__body {
    padding-top: 0;
    height: calc(100% - 120px);
    max-height: 100%;
  }
  .el-dialog__footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Dialog.vue